import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadableAfterPaint } from '@confluence/loadable';

const AppsPermissionsSettingsPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-AppsPermissionsSettingsPageRouteComponent" */ './AppsPermissionsSettingsPageRouteComponent.tsx'
		),
});

export const AppsPermissionsSettingsPageRoute = () => <AppsPermissionsSettingsPageRouteComponent />;

AppsPermissionsSettingsPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'appPermissionsSettingsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
